module.exports = __webpack_public_path__ + "components/rating/static/star-full-57e42ce7315c42eb3a9aec8ed08dabc3.svg";